bovoApp.controller('ThirdPartyController', ['$scope', '$http',
  function ($scope, $http) {
    $scope.f = { source: 'all', store: '', issue: '', date: '7' };
    $scope.data = { data: [], total: 0, current_page: 1, unmatched: 0, mismatched: 0 };
    $scope.stores = [];
    $scope.loaded = false;

    $scope.onSourceChange = function () {
      if ($scope.f.source === 'hb') {
        $http.get('/api/third-party/stores', { params: { source: 'hb' } }).then(function (res) {
          $scope.stores = res.data;
        });
      } else {
        $scope.stores = [];
      }
      $scope.f.store = '';
      $scope.load();
    };

    $scope.load = function () {
      $http.post('/api/third-party/orders', $scope.f).then(function (res) {
        $scope.data = res.data;
        $scope.data.current_page = res.data.current_page || 1;
        $scope.loaded = true;
      });
    };

    $scope.getPage = function (page) {
      $http.post('/api/third-party/orders', angular.extend({}, $scope.f, { page: page })).then(function (res) {
        $scope.data.data = res.data.data;
        $scope.data.current_page = page;
      });
    };

    $scope.fixOne = function (o) {
      if (!o.bovo_id) return alert('Eslesme yok, duzeltilemez');
      o._fixing = true;
      $http.post('/api/third-party/fix-single', { order_id: o.bovo_id }).then(function (res) {
        if (res.data.error) {
          alert(res.data.error);
        } else {
          var d = res.data;
          var msg = '#' + o.bovo_id + ' duzeltildi. Ref: ' + d.old_ref + ' -> ' + d.new_ref + ' (' + d.hb_carrier + ')';
          if (d.carrier_changed_hb) msg += '. HB kargo DHL yapildi!';
          if (d.work_type_changed) msg += '. Bovo : ' + d.bovo_carrier;
          alert(msg);
          $scope.load();
        }
      }).finally(function () { o._fixing = false; });
    };

    $scope.fixAll = function () {
      if (!confirm('Tum bozuk referanslar duzeltilsin mi?')) return;
      $scope.fixing = true;
      $http.post('/api/third-party/fix-refs').then(function (res) {
        alert('Duzeltilen: ' + res.data.fixed + ', Basarisiz: ' + res.data.failed);
        $scope.load();
      }).finally(function () { $scope.fixing = false; });
    };
  }
]);
